import Vue from 'vue';
import Blazy from 'blazy';

Vue.directive('lazy', {
    bind(el, binding) {
        const bLazyClass = `b-lazy`;
        el.classList.add(bLazyClass);

        if(binding.modifiers.blur) {
            el.style.filter = 'blur(10px)';
            el.style.transition = 'filter .5s ease-out';
        }

        if(binding.value) {
            let defaultSrc = Vue.helpers.image(binding.value, `${el.clientWidth > 2560 ? 2560 : el.clientWidth}x0_ratio`);
            let retinaSrc = Vue.helpers.image(binding.value, `${el.clientWidth * 2 > 2560 ? 2560 : el.clientWidth * 2}x0_ratio`);

            el.dataset.src = `${defaultSrc}|${retinaSrc}`;
        }
    },

    inserted(el) {
        Vue.nextTick(() => {
            setTimeout(() => Vue.blazy.load(el), 100);
        });
    },
});


// WEBPACK FOOTER //
// ../default-js/js/directives/imageLazyLoad.js